<template>
  <DomainCrawlScheduleForm :crawl-schedule="crawl_schedule" @submit="onSubmit($event)"></DomainCrawlScheduleForm>
</template>

<script>

  import DomainCrawlScheduleForm from './DomainCrawlScheduleForm';
  import DomainService from "../services/Domain.service";

  export default {
    name: 'DomainCrawlScheduleAdd',
    components: {
      DomainCrawlScheduleForm
    },
    data() {
      return {
        crawl_schedule: {
          domain_id: null,
          name: null,
          crawl_depth: 5,
          interval: null,
          user_agent_id: null,
          text_string_appear: null,
          text_string_not_appear: null,
          policy_id: null
        }
      };
    },
    methods: {
      onSubmit(event) {
        DomainService.addDomainCrawlSchedule(event).then(() => {
          this.$router.push('/domain/list-crawl-schedule');
          this.$showSuccessMessage('Added Crawl Schedule');
        });
      }
    }
  };
</script>

<style lang="scss" scoped></style>
